import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => {
  return {
    user: state.user.user,
    isRewardsUser: state?.user?.user?.applications?.some((x) => x?.name?.includes('Rewards')),
    userInfo: state.user.loyaltyStatistics,
    userDetail: state.user.user,
    pets: state.pet.userPets,
    subComponent: state.statsbar.activeComponent,
  };
};

angular
  .module('myConsultApp')
  .controller('statsBarController', ($ngRedux, $scope, $rootScope) => {
    $scope.userInfoMap = [
      { key: 'redeemable_points', title: 'Redeemable Points', default: 0 },
      { key: 'total_points', title: 'Total Points', default: 0 },
      { key: 'submitted_transactions', title: 'Submitted Transactions', default: 0 },
      { key: 'dollars_spent', title: 'Dollars Spent', default: '$0.00' },
      { key: 'rewards_redeemed', title: 'Rewards Redeemed', default: '$0.00' },
    ];
    $rootScope.componentOpened = false;

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.showActionMenu = () => {
      $rootScope.isActionMenu = !$rootScope.isActionMenu;
    };

    $scope.emailUser = (email, subject, body, $event) => {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      $rootScope.isActionMenu = false;
      window.open('mailto:' + email + '?subject=' + subject + '&body=' + body, '_self');
    };

    $(document).on('click', (event) => {
      const settingEle = $('.user-actions');

      if (settingEle !== event.target && !settingEle.has(event.target).length) {
        $scope.$apply(() => {
          $rootScope.isActionMenu = false;
        });
      }
    });

    $scope.init();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      $rootScope.userDetailExpanded = false;
      $scope.mediaId = null;
      if (!$rootScope.isUserPage) {
        $rootScope.userId = null;
      }
    });
  })
  .directive('statsBar', () => {
    return {
      templateUrl: 'templates/v2/stats-bar.html',
    };
  });
